// extracted by mini-css-extract-plugin
export var messageSideLeft = "_p5-1";
export var messageSideRight = "_p5-2";
export var subscribeToBackInStockBubbleContainer = "_p5-0";